















































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { mapGetters } from "vuex";

axios.defaults.baseURL = process.env.BASE_URL;

@Component({
  computed: mapGetters(["getUser"])
})
export default class NormatifQuestionnaireExplorer extends Vue {
  baseurl = process.env.BASE_URL;
  getUser: any;

  normatifTests: Array<any> = [];
  userCredits: any = {};
  selected: any = null;

  get normatifQuestionnaires() {
    return this.normatifTests
      .filter(test => this.hasNormatifTestCredit(test.id || test._id))
      .map(test => ({
        id: test.id || test._id,
        qtype: test.name || test._id,
        creationDate: new Date(test.createdAt || new Date()),
        referrer: { origin: { userId: test.createdBy || "Admin" } },
        meta: { hovered: false },
        etat: test.etat || "not_started",
        qId: test.qId || null
      }));
  }

  hasNormatifTestCredit(testId: string): boolean {
    return this.userCredits[`NORMATIF_TEST_${testId}`] > 0;
  }

  async loadUserCredits() {
    try {
      const response = await axios.get("/api/balance", {
        params: { userId: this.getUser.id }
      });
      this.userCredits = response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des crédits:", error);
    }
  }

  async loadNormatifTests() {
    try {
      const response = await axios.get("/api/tests");
      this.normatifTests = response.data;
     

     
      const statusRes = await axios.get("/api/normatif-status/all");
      

   
      this.normatifTests = this.normatifTests.map((test: any) => {
        const id = test.id || test._id;
        const status = statusRes.data[id] || { etat: "not_started", qId: null };
        return {
          ...test,
          etat: status.etat,
          qId: status.qId
        };
      });

    
    } catch (error) {
      console.error("Erreur lors du chargement des tests normatifs:", error);
    }
  }

  startNormatifTest(testId: string) {
    this.$router.push(this.baseurl + "normatif-questionnaire/" + testId);
  }

  continueNormatifTest(testId: string) {
    this.$router.push(this.baseurl + "normatif-questionnaire/" + testId);
  }

consultNormatifTest(testId: string) {
  const test = this.normatifTests.find(t => (t.id || t._id) === testId);
  if (!test || !test.qId) {
    console.error("Pas de qId trouvé pour le test:", testId);
    return;
  }

  this.$router.push({
    path: this.baseurl + "normatif-questionnaire/" + testId,
    query: { qId: test.qId, viewOnly: "true" }
  });
}

  clickAnswer(a: any) {
    this.selected = a;
  }

  hoverAnswer(a: any, hovered: boolean) {
    a.meta.hovered = hovered;
  }

  mounted() {
    this.loadNormatifTests();
    this.loadUserCredits();
  }
}
